import * as React from "react";
import BootstrapPagination from "react-bootstrap/Pagination";

import style from "./style.module.css";

interface PaginationProps {
  totalPages: number;
  totalCount: number;
  currentPage: number;
  onChangePage(page: number): void;
}

export function Pagination(props: PaginationProps) {
  const { totalPages, currentPage, totalCount, onChangePage } = props;

  const startPage = Math.max(1, currentPage - 5);
  const endPage = Math.min(totalPages, currentPage + 5);
  const pageItems = [];
  for (let page = startPage; page <= endPage; page++) {
    pageItems.push(
      <BootstrapPagination.Item
        key={page}
        active={page === currentPage}
        onClick={() => onChangePage(page)}
      >
        {page}
      </BootstrapPagination.Item>,
    );
  }
  if (startPage > 1) {
    pageItems.unshift(
      <BootstrapPagination.Ellipsis
        key="start-ellipsis"
        onClick={() => onChangePage(startPage - 1)}
      />,
    );
  }
  if (endPage < totalPages) {
    pageItems.push(
      <BootstrapPagination.Ellipsis
        key="end-ellipsis"
        onClick={() => onChangePage(endPage + 1)}
      />,
    );
  }

  return (
    <div className={style.footer}>
      <nav>
        <BootstrapPagination>
          <BootstrapPagination.First
            disabled={currentPage === 1}
            onClick={() => onChangePage(1)}
          />
          <BootstrapPagination.Prev
            disabled={currentPage === 1}
            onClick={() => onChangePage(currentPage - 1)}
          />
          {pageItems}
          <BootstrapPagination.Next
            disabled={currentPage === totalPages}
            onClick={() => onChangePage(currentPage + 1)}
          />
          <BootstrapPagination.Last
            disabled={currentPage === totalPages}
            onClick={() => onChangePage(totalPages)}
          />
        </BootstrapPagination>
      </nav>
      <div className={style.pageCount}>{totalCount} results.</div>
    </div>
  );
}
